import React from 'react';
import './journeyMobileCard.css'
import C2wSuperxJourneyIndexHolder from './indexHolder';

function C2wJourneyMobileCard( { obj=null, index=null} ) {
  return (
    <div className='C2wSuperxJourneyMobileCard_ctn'>
      <C2wSuperxJourneyIndexHolder index={index} />
      <div className='C2wSuperxJourneyMobileCard_ctn_heading'>{obj.heading}</div>
      <p className='C2wSuperxJourneyMobileCard_ctn_infopara'>{obj?.infoPara}</p>
    </div>
  )
}

export default C2wJourneyMobileCard